import { cn } from "@/lib/utils";

interface MobileJobTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  jobType?: string;
}

export const MobileJobTabs = ({ activeTab, onTabChange, jobType }: MobileJobTabsProps) => {
  const tabs = jobType === "Insurance" 
    ? ["Overview", "Trades", "Photo Hub", "Measurement/Estimate"]
    : jobType === "Commercial"
    ? ["Overview", "Trades", "Photo Hub", "Quick Estimate"]
    : ["Overview", "Trades", "Photo Hub", "Measurement/Estimate"];

  return (
    <div
      className="fixed left-0 right-0 z-40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 border-t shadow-lg"
      style={{ bottom: "calc(64px + env(safe-area-inset-bottom, 0px))" }}
    >
      <div className="flex overflow-x-auto no-scrollbar">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => onTabChange(tab)}
            className={cn(
              "flex-1 min-w-[100px] px-2 py-4 text-[10px] font-semibold transition-colors whitespace-nowrap leading-tight",
              activeTab === tab
                ? "text-primary border-b-2 border-primary bg-primary/5"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
};
